/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type {Calendar} from './calendar';
// May contain unused imports in some cases
// @ts-ignore
import type {HarvestPlantShift} from './harvest-plant-shift';

/**
 *
 * @export
 * @interface HarvestPlant
 */
export interface HarvestPlant {
  /**
   *
   * @type {string}
   * @memberof HarvestPlant
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof HarvestPlant
   */
  planId: string;
  /**
   *
   * @type {string}
   * @memberof HarvestPlant
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof HarvestPlant
   */
  packagingCode: string | null;
  /**
   *
   * @type {number}
   * @memberof HarvestPlant
   */
  longitude: number;
  /**
   *
   * @type {number}
   * @memberof HarvestPlant
   */
  latitude: number;
  /**
   *
   * @type {Calendar}
   * @memberof HarvestPlant
   */
  calendar: Calendar;
  /**
   *
   * @type {boolean}
   * @memberof HarvestPlant
   */
  assignToAllSites: boolean;
  /**
   *
   * @type {string}
   * @memberof HarvestPlant
   */
  regionId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof HarvestPlant
   */
  siteIds: Array<string>;
  /**
   *
   * @type {Array<HarvestPlantShift>}
   * @memberof HarvestPlant
   */
  shifts: Array<HarvestPlantShift>;
  /**
   *
   * @type {string}
   * @memberof HarvestPlant
   */
  primarySpecies?: HarvestPlantPrimarySpeciesEnum;
  /**
   *
   * @type {string}
   * @memberof HarvestPlant
   */
  costType: HarvestPlantCostTypeEnum;
}

export const HarvestPlantPrimarySpeciesEnum = {
  Salmon: 'salmon',
  Trout: 'trout',
} as const;

export type HarvestPlantPrimarySpeciesEnum =
  (typeof HarvestPlantPrimarySpeciesEnum)[keyof typeof HarvestPlantPrimarySpeciesEnum];
export const HarvestPlantCostTypeEnum = {
  Biomass: 'biomass',
  Count: 'count',
} as const;

export type HarvestPlantCostTypeEnum = (typeof HarvestPlantCostTypeEnum)[keyof typeof HarvestPlantCostTypeEnum];
